
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Acfourfiveseater() {



    const cardData =
    {
        keyword: 'Ac 45 Seater Bharat Benz Bus Hire Aurangabad ( Sambhaji Nagar )',
        heading: 'Amruta Travels: Ac 45 Seater Bharat Benz Bus Hire Aurangabad ( Sambhaji Nagar )',
        headingDescription: 'Amruta Travels offers AC 45 Seater BharatBenz Bus Hire in Aurangabad (Sambhaji Nagar), providing a luxurious and comfortable transportation solution for your group travel needs. Whether you are planning a corporate event, family trip, wedding, or group tour, our well-maintained BharatBenz buses ensure a smooth and enjoyable journey. Equipped with air-conditioned interiors, plush seating, and ample luggage space, our 45-seater buses are designed for maximum comfort and reliability. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your travel in and around Aurangabad simple and stress-free.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

   "services": [
    {
      "name": "Pune to Sambhaji Nagar 45 Seater Bus Hire",
      "description": "Travel from Pune to Sambhaji Nagar (Aurangabad) with our 45-seater AC buses. Ideal for group tours, educational trips, and religious visits, our buses offer spacious seating, air-conditioning, and a smooth travel experience across long distances."
    },
    {
      "name": "AC Bharat Benz Bus Rental Aurangabad Trip",
      "description": "Book an AC Bharat Benz bus for your Aurangabad trip from Pune. These luxury buses are perfect for corporate outings, family vacations, or group tours, offering reliable performance, pushback seats, and onboard comfort for all passengers."
    },
    {
      "name": "Outstation Bus for Sambhaji Nagar from Pune",
      "description": "Amruta Travels provides outstation bus rental from Pune to Sambhaji Nagar. Our fleet includes comfortable AC coaches with experienced drivers, ensuring a safe and enjoyable journey for tourists, students, or business groups."
    },
    {
      "name": "Luxury Bus Aurangabad Tour",
      "description": "Experience the heritage of Aurangabad in luxury with our premium bus services. Our luxury coaches come equipped with AC, pushback seats, and entertainment systems, making them ideal for heritage tours, corporate retreats, or VIP travel."
    },
    {
      "name": "Pune to Ajanta Ellora Bus Hire",
      "description": "Plan a group visit to the famous Ajanta and Ellora Caves with our Pune to Aurangabad bus service. Perfect for educational, cultural, and family trips, our AC buses ensure a relaxed and scenic travel experience."
    },
    {
      "name": "Corporate Trip Bus Aurangabad",
      "description": "Organize corporate tours from Pune to Aurangabad with Amruta Travels’ professional bus rental services. We offer AC coaches tailored for company outings, team-building events, and business travel, with flexible pickup points and schedules."
    },
    {
      "name": "Family Tour Bus to Aurangabad",
      "description": "Book a family bus tour to Aurangabad with comfortable and spacious seating. Whether visiting religious landmarks or historical sites, our 45-seater AC buses provide a safe and relaxed travel option for all age groups."
    },
    {
      "name": "Volvo AC Coach to Sambhaji Nagar",
      "description": "Hire a luxury Volvo AC coach for your trip to Sambhaji Nagar. With plush interiors, ample legroom, and smooth suspension, our Volvo buses are ideal for long journeys, ensuring a premium travel experience for your group."
    },
    {
      "name": "45 Seater Historical Tour Bus",
      "description": "Explore Aurangabad's historical treasures in comfort with our 45-seater buses. Suitable for school field trips, college tours, or tourist groups, our buses are maintained to high standards and driven by professional staff."
    },
    {
      "name": "Pune Tourist Bus Rental",
      "description": "Amruta Travels offers tourist bus rentals from Pune to major attractions in and around Aurangabad. Choose from AC coaches, mini-buses, or luxury buses depending on group size and travel preference."
    },
    {
      "name": "Sambhaji Nagar Event Bus",
      "description": "Organizing an event in Sambhaji Nagar? We provide buses for weddings, conferences, exhibitions, and cultural events. Our buses offer punctual service, comfortable seating, and options from 25 to 50 seaters."
    },
    {
      "name": "Bharat Benz Group Tour Bus",
      "description": "Enjoy a group tour to Aurangabad with our AC Bharat Benz buses. Designed for comfort and safety, these buses are ideal for multi-day trips, family vacations, and society travel plans from Pune."
    },
    {
      "name": "Pune Long Trip AC Bus",
      "description": "Looking for a long-distance bus from Pune? Our AC buses are designed for extensive travel, offering comfort, safety, and space for luggage, perfect for tours to Sambhaji Nagar and nearby destinations."
    },
    {
      "name": "Wedding Function Bus Sambhaji Nagar",
      "description": "Book wedding transportation to and from Sambhaji Nagar with our 45-seater AC buses. We provide punctual, elegant, and reliable group travel for marriage functions and guest movement."
    },
    {
      "name": "VIP Bus Service Pune to Aurangabad",
      "description": "Travel in style with our VIP bus rental services from Pune to Aurangabad. Featuring plush seating, onboard entertainment, and premium interiors, these buses are ideal for dignitaries, VIPs, and high-end corporate travel."
    }
  ],
  "tableData": [
    ["Pune to Sambhaji Nagar 45 Seater Bus Hire", "AC Bharat Benz Bus Rental Aurangabad Trip"],
    ["Outstation Bus for Sambhaji Nagar from Pune", "Luxury Bus Aurangabad Tour"],
    ["Pune to Ajanta Ellora Bus Hire", "Corporate Trip Bus Aurangabad"],
    ["Family Tour Bus to Aurangabad", "Volvo AC Coach to Sambhaji Nagar"],
    ["45 Seater Historical Tour Bus", "Pune Tourist Bus Rental"],
    ["Sambhaji Nagar Event Bus", "Bharat Benz Group Tour Bus"],
    ["Pune Long Trip AC Bus", "Wedding Function Bus Sambhaji Nagar"],
    ["VIP Bus Service Pune to Aurangabad"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "AC 45 Seater Bharat Benz Bus Hire in Aurangabad (Sambhaji Nagar)",
    "WhyChoosedescription": "Amruta Travels offers comfortable and luxurious AC 45 Seater Bharat Benz buses for hire in Aurangabad (Sambhaji Nagar). Whether you're traveling for a corporate event, a family trip, or a religious pilgrimage, our buses provide a reliable, safe, and enjoyable journey to and from Aurangabad."
  },
  {
    "WhyChooseheading": "Comfortable, Air-Conditioned Travel for Large Groups",
    "WhyChoosedescription": "Our AC 45 Seater Bharat Benz buses are equipped with top-of-the-line air-conditioning, spacious seating, and ample legroom, ensuring that your group travels comfortably. Whether it's a short or long journey, our buses offer a relaxed, pleasant, and smooth ride to Aurangabad."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Family, and Religious Group Travel",
    "WhyChoosedescription": "Amruta Travels provides the perfect bus hire solution for a variety of group travel needs in Aurangabad. From corporate conferences and team outings to family vacations and religious pilgrimages, our 45 Seater Bharat Benz buses accommodate large groups with ease and comfort."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for Safe Travel",
    "WhyChoosedescription": "Our drivers are experienced, licensed, and familiar with the routes around Aurangabad (Sambhaji Nagar) and nearby destinations. They prioritize safety, punctuality, and customer satisfaction, ensuring your group enjoys a smooth and worry-free journey."
  },
  {
    "WhyChooseheading": "Well-Maintained Buses for a Safe and Comfortable Journey",
    "WhyChoosedescription": "We pride ourselves on our fleet of well-maintained 45 Seater Bharat Benz buses. Regular maintenance and safety checks ensure that every bus is in top condition, offering you a reliable and stress-free travel experience every time."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Group Travel",
    "WhyChoosedescription": "Our pricing for 45 Seater Bharat Benz bus rentals is competitive and transparent. The rate includes fuel, tolls, driver allowances, and taxes, with no hidden charges. This ensures that you can plan your trip to Aurangabad without any unexpected costs."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans to Meet Your Group's Needs",
    "WhyChoosedescription": "We offer flexible and customizable bus rental services. Whether you need specific pick-up or drop-off points or have other special requests, Amruta Travels is happy to accommodate your needs for a seamless and tailored travel experience."
  },
  {
    "WhyChooseheading": "Easy Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking your AC 45 Seater Bharat Benz bus for Aurangabad is quick and easy with Amruta Travels. You can reserve a bus online, over the phone, or by visiting our office. Our 24/7 customer support team is available to assist with bookings, itinerary changes, or any other questions."
  }
]

























    }

const faqData = [
  {
    question: 'Can I hire an AC 45-seater Bharat Benz bus for a trip to Aurangabad (Sambhaji Nagar) with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers AC 45-seater Bharat Benz buses for hire for trips to Aurangabad (Sambhaji Nagar). Our buses provide the perfect blend of comfort and luxury, ensuring a pleasant and safe journey to your destination.',
  },
  {
    question: 'What amenities are available in the AC 45-seater Bharat Benz bus?',
    answer: 'The AC 45-seater Bharat Benz buses are equipped with comfortable reclining seats, air conditioning, USB charging ports, overhead storage, ample legroom, clean interiors, and entertainment options, ensuring a comfortable and relaxing journey.',
  },
  {
    question: 'Is the AC 45-seater Bharat Benz bus suitable for both local and outstation travel?',
    answer: 'Yes, the AC 45-seater Bharat Benz bus is perfect for both local travel within Aurangabad (Sambhaji Nagar) and outstation trips. It is ideal for long-distance travel, providing comfort and safety for all passengers.',
  },
  {
    question: 'Is a driver included in the bus rental for the Aurangabad trip?',
    answer: 'Yes, every rental of the AC 45-seater Bharat Benz bus comes with an experienced, professional driver. Our drivers are well-trained, familiar with the local routes, and ensure a safe and timely trip to Aurangabad (Sambhaji Nagar).',
  },
  {
    question: 'How much does it cost to hire an AC 45-seater Bharat Benz bus for a trip to Aurangabad?',
    answer: 'The cost of hiring an AC 45-seater Bharat Benz bus for a trip to Aurangabad depends on the distance, duration, and specific requirements of your trip. Typically, prices range from ₹30–₹40 per km. For an accurate quote, please contact us with your travel details.',
  },
  {
    question: 'Is the AC 45-seater Bharat Benz bus comfortable for long journeys?',
    answer: 'Yes, the AC 45-seater Bharat Benz bus is designed to provide maximum comfort on long journeys. With spacious seating, air conditioning, and modern amenities, it ensures a smooth and enjoyable ride, whether traveling to Aurangabad for business or leisure.',
  },
  {
    question: 'Are the buses well-maintained and sanitized?',
    answer: 'Absolutely. All our buses, including the AC 45-seater Bharat Benz, are regularly maintained, cleaned, and sanitized before each trip to ensure safety, hygiene, and comfort for all passengers.',
  },
  {
    question: 'How do I book an AC 45-seater Bharat Benz bus for a trip to Aurangabad?',
    answer: 'You can easily book an AC 45-seater Bharat Benz bus for your trip to Aurangabad online through our website or by contacting our customer support team. We provide fast booking assistance and tailor our services to fit your travel needs.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Manish Deshmukh',
    role: 'Tour Organizer, Pune',
    text: 'We hired an AC 45-seater Bharat Benz bus for a trip to Aurangabad (Sambhaji Nagar). The bus was spacious, comfortable, and well-equipped. The driver was very professional, and the entire journey was smooth and enjoyable. I would highly recommend Amruta Travels for any group travel.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Rekha Patil',
    role: 'Corporate Event Planner, Pune',
    text: 'Amruta Travels provided an excellent bus for our corporate event trip to Aurangabad. The AC 45-seater Bharat Benz bus was luxurious and comfortable, with great amenities. The service was impeccable, and we had a very pleasant experience.',
    rating: 5,
  },
];































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC 45 Seater Bharat Benz Bus Hire Aurangabad (Sambhaji Nagar)",
  "image": "https://bushireinpune.com/assets/images/45-seater-bharat-benz-aurangabad.jpg",
  "description": "Amruta Travels offers AC 45 Seater Bharat Benz Bus Hire for your Aurangabad trip. Explore Sambhaji Nagar, Ajanta Ellora caves, corporate events, family tours, and historical tours with our luxury buses. Choose from premium buses like Bharat Benz and Volvo for a comfortable and safe journey from Pune to Aurangabad, including options for weddings, VIP services, and long-distance trips.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "14568"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "17000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/ac-45-seater-bharat-benz-bus-hire-aurangabad"
  }
};







    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | AC 45 Seater Bharat Benz Bus Hire Aurangabad | Pune to Sambhaji Nagar & Ajanta Ellora</title>
  <meta 
    name="description" 
    content="Hire an AC 45 Seater Bharat Benz bus for your Aurangabad trip. Comfortable and luxury bus rental for group tours, corporate events, family tours, and historical tours from Pune to Sambhaji Nagar, Ajanta, and Ellora." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Acfourfiveseater;